<template>
  <el-dialog title="设置新密码" :visible="showSetNewPassword" top="0" append-to-body width="600px" :before-close="handleCancel" :show-close="!pswdFlag" :close-on-click-modal="!pswdFlag" :close-on-press-escape="!pswdFlag">
    <el-form label-position="top" ref="setNewPasswordFrom" :model="setNewPasswordFrom" :rules="rules" label-width="150px">
      <el-form-item label="新密码" prop="newPassword">
        <el-input v-model="setNewPasswordFrom.newPassword" type="password" placeholder="请输入8-20位新密码，需包含大小写字母、数字以及特殊字符" clearable show-password> </el-input>
      </el-form-item>

      <el-form-item label="确认新密码" prop="confirmPassword">
        <el-input v-model="setNewPasswordFrom.confirmPassword" type="password" placeholder="请再次输入新密码" clearable show-password> </el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleCancel" v-show="!pswdFlag">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { setChangePassword } from '@/api/verifyCode';
import envConfig from '@/config';
const baseURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_BASE_URL`];
export default {
  props: {
    showSetNewPassword: {
      type: Boolean,
      default: false,
    },
    verifyCode: {
      type: String,
      default: '',
    },
  },
  data() {
    // 密码验证规则
    const validatePassword = (rule, value, callback) => {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,20}$/;
      const message = '请输入8-20位新密码，需包含大小写字母、数字以及特殊字符';
      const condition = regex.test(value);
      return callback(condition ? undefined : message);
    };

    return {
      setNewPasswordFrom: {
        newPassword: '',
        confirmPassword: '',
      },
      rules: {
        newPassword: [{ required: true, validator: validatePassword, trigger: 'change' }],
        confirmPassword: [{ required: true, validator: validatePassword, trigger: 'change' }],
      },
    };
  },
  watch: {},
  computed: {
    ...mapState('user', ['phone', 'passwordState', 'openId']),
    pswdFlag() {
      return this.passwordState;
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 取消操作
    handleCancel() {
      this.$emit('changeSetNewPassword', false);
    },

    // 确认操作
    async handleConfirm() {
      try {
        const isValid = await new Promise((resolve) => {
          this.$refs.setNewPasswordFrom.validate(resolve);
        });

        if (!isValid) {
          return; // 校验失败，直接返回
        }
        // 检查两次密码是否一致
        if (this.setNewPasswordFrom.newPassword !== this.setNewPasswordFrom.confirmPassword) {
          this.$message.error('两次密码不一致');
          return;
        }
        const response = await setChangePassword({
          code: this.verifyCode,
          newPassword: this.setNewPasswordFrom.newPassword,
          phone: this.phone,
        });
        if (response.code == 0) {
          // 密码修改成功
          this.$message.success(response.msg);
          // 清空表单
          this.$refs.setNewPasswordFrom.resetFields();
          // 关闭弹窗
          this.$emit('changeSetNewPassword', false);
          // 退出登录
          localStorage.removeItem('token');
          localStorage.removeItem('userInfo');
          window.location.href = `${baseURL}/riskcontrol/oauth/logout`;
        } else {
          this.$message.error(response.msg);
        }
      } catch (error) {
        this.$message.error('修改密码失败，请重试');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  border-radius: 8px;

  .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;

    .el-dialog__title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }

  .el-dialog__body {
    padding: 30px 40px;

    .el-form-item {
      margin-bottom: 25px;

      .el-input {
        width: 100%;
      }

      .password-tip {
        font-size: 12px;
        color: #999;
        margin-top: 5px;
      }
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>
